import _ from 'underscore';
import $ from 'jquery';
import Numeral from 'numeral';
import UI from 'root/ui';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Router from 'root/router';
import Tooltip from 'root/module/tooltip';
import Form from 'root/module/form';
import View from 'view/base';
import Modals from 'root/modals';
import View_Survey_Response_Row from 'view/survey_response/response_row';
import View_Survey_Response_Filters from 'view/survey_response/filters';

const Page_Survey_Results = View.extend({
    tagName: 'section',
    className: 'fullscroll', // with fullscroll-action-bar

    survey: null,

    page: 1,
    limit: 30,
    total: null, // null: loading, 0: no data, >0: has data,
    total_responses: 0,

    search_val: '',
    selected_ids: [],

    questions: [],

    filters: {
        segments: [],
        user_property_filter: {},
        date_start: 0
    },

    views: {
        response_rows: {},
        filters: {}
    },

    events: {
        'click .page-previous'      : 'onPagePrevious',
        'click .page-next'          : 'onPageNext',
        'click .quick-search-clear' : 'onQuickSearchClear',
        'submit .quick-search'      : 'onQuickSearch',
        'click td.select input'     : 'onSelectRow',
        'click .clear-selection'    : 'onClearSelection',
        'click .response-export'    : 'onExport',
        'click .select-all input'   : 'onSelectAll',
        'click .delete'             : 'onDelete',
    },

    dom_handlers: {
        onPagePrevious: function(e) {
            if (this.page <= 1) {
                return;
            }
            this.selected_ids = [];
            this.page--;

            this.search();
        },

        onPageNext: function(e) {
            var total_page = Math.ceil(this.total / this.limit);
            this.selected_ids = [];
            if (this.page >= total_page) {
                return;
            }

            this.page++;

            this.search();
        },

        onQuickSearchClear: function() {
            Tooltip.removeAll();

            this.search_val = '';
            Router.removeQueryString('search');

            this.$el.find('.quick-search').find('input').val('');
            this.search();
        },

        onQuickSearch: function(e) {
            var form_data = Form.getData(this.$el.find('.quick-search'));

            this.page = 1;
            this.search_val = form_data.search;

            Router.addQueryString('search', this.search_val);

            this.search();
        },

        onSelectRow: function(e) {
            var model_id = $(e.currentTarget).data('val');

            if ($(e.currentTarget).prop('checked')) {
                // check id is not in the list
                if (this.selected_ids.indexOf(model_id) === -1) {
                    this.selected_ids.push(model_id);
                }
            } else {
                this.selected_ids = this.selected_ids.filter(id => id !== model_id);
            }

            this.$el.find('.fullscroll-action-bar > div').toggleClass('flip', this.selected_ids.length > 0);
            this.$el.find('.item-counter .num').text(this.selected_ids.length + ' response' + (this.selected_ids.length === 1 ? '' : 's'));
        },

        onClearSelection: function(e) {
            e.preventDefault();
            this.onClearSelection();
        },

        onExport: function() {
            if (Cache.account.get('is_expired')) {
                Modals.expiredAccount();
                return;
            }

            if (!Cache.account.hasFeature('export_feedback')) {
                Modals.unlockFeature();
                return;
            }

            // TODO: Free plan

            Cache.app.request({
                action: 'survey_response/export',
                data: {
                    id                : this.survey.id,
                    search            : this.search_val,
                    date_start        : this.filters.date_start,
                    segment_id        : this.filters.segments.length === 0 ? undefined : this.filters.segments[0],
                    user_properties   : this.filters.user_properties,
                    question_condition: this.filters.question_condition
                },
                success: (response) => {
                    if (response) {
                        UI.success('You will be emailed a CSV when it\'s ready. This may take several minutes.', 10);
                    }
                }
            });
        },

        onSelectAll: function(e) {
            var is_select_all = $(e.currentTarget).prop('checked');

            this.$el.find('.select input:checkbox').not(':disabled').prop('checked', !is_select_all).click();
        },

        onDelete: function(e) {
            var selected_ids = this.selected_ids;

            if (selected_ids.length === 0) {
                return;
            }

            Modals.deleteSurveyResponse(this.survey.id, selected_ids, () => {
                $(e.currentTarget).addClass('loading').prop('disabled', true);
            }, () => {
                $(e.currentTarget).removeClass('loading').prop('disabled', false);
                this.search();
                this.onClearSelection();
            });
        }
    },

    event_handlers: {
        onReset: function() {
            // remove existing views
            _.each(this.views.response_rows, (view) => {
                view.remove();
            });

            this.views.response_rows = {};

            Cache.survey_response.forEach((model) => {
                this.views.response_rows['_' + model.id] = new View_Survey_Response_Row({
                    model: model,
                    questions: this.questions,
                    user_data: this.user_data
                });
            });

            this.renderDataTable();
        },
        // when filter_names is empty, it will save all filters
        onFilterChange: function(filters, filter_names = []) {
            this.page = 1;

            this.filters = {...filters};

            this.search(() => {
                this.$el.find('.fullscroll-action-bar > div').removeClass('flip');
                this.$el.find('.item-counter .num').text('');
            });

            if (filter_names.length === 0) {
                filter_names = ['segments', 'date_start', 'user_properties', 'question_condition'];
            }

            filter_names.forEach((filter_name) => {
                switch(filter_name) {
                    case 'segments':
                        if (this.filters.segments.length) {
                            Cache.app.addUserSetting('survey_response_filter_segment', this.filters.segments.join(','), true);
                        } else {
                            Cache.app.deleteUserSetting('survey_response_filter_segment', true);
                        }
                        break;
                    case 'date_start':
                        if (this.filters.date_start) {
                            Cache.app.addUserSetting('survey_response_filter_date', this.filters.date_start, true);
                        } else {
                            Cache.app.deleteUserSetting('survey_response_filter_date', true);
                        }
                        break;
                    case 'user_properties':
                        if (this.filters.user_properties.segment_condition.length) {
                            Cache.app.addUserSetting('survey_response_filter_user_properties', JSON.stringify(this.filters.user_properties), true);
                        } else {
                            Cache.app.deleteUserSetting('survey_response_filter_user_properties', true);
                        }
                        break;
                    case 'question_condition':
                        if (this.filters.question_condition.question_condition.length) {
                            Cache.app.addUserSetting('survey_response_filter_question_condition', JSON.stringify(this.filters.question_condition), true);
                        } else {
                            Cache.app.deleteUserSetting('survey_response_filter_question_condition', true);
                        }
                        break;
                }
            });
        }
    },

    initialize: function() {
        this.filters = {
            segments: [],
            date_start: 0,
            user_properties: {
                segment_type: Constants.USER_SEGMENT_TYPE_AND,
                segment_condition: []
            },
            question_condition: {
                question_condition_type: Constants.QUESTION_CONDITION_TYPE_AND,
                question_condition: []
            }
        };

        this.selected_ids = [];

        this.filters.segments   = this.validateSegement();
        this.filters.date_start = this.validateStartDate();
        this.filters.user_properties = this.validateUserProperties();
        this.filters.question_condition = this.validateQuestionCondition();

        this.filters.segments = this.filters.segments.map((segment_id) => {
            return parseInt(segment_id, 10);
        }).filter((segment_id) => {
            return Cache.user_segment.get(segment_id) ? true : false;
        });

        this.survey = Cache.survey.findWhere({project_id: Cache.default_project_id});  // only one survey per project right now, later the survey ID will be in the URL
        this.questions = Cache.survey_question.models.filter((model) => {
            return ['welcome', 'thankyou'].indexOf(model.get('question_type')) === -1;
        });

        this.views.filters = new View_Survey_Response_Filters(this.filters);

        this.search_val = Router.getQueryString('search') || '';

        this.listenTo(Cache.survey_response, 'reset', this.event_handlers.onReset);
        this.listenTo(this.views.filters, 'filter:change', this.event_handlers.onFilterChange);
    },

    search: function(on_success, skip_route_change = false) {
        if (!skip_route_change) {
            const add_query_strings = {};
            const remove_query_strings = [];

            // Add or remove query strings based on filter conditions
            if (this.filters.question_condition.question_condition.length) {
                add_query_strings.question_condition = JSON.stringify(this.filters.question_condition);
            } else {
                remove_query_strings.push('question_condition');
            }

            if (this.filters.user_properties.segment_condition.length) {
                add_query_strings.user_property = JSON.stringify(this.filters.user_properties);
            } else {
                remove_query_strings.push('user_property');
            }

            if (this.filters.date_start) {
                add_query_strings.d = this.filters.date_start;
            } else {
                remove_query_strings.push('d');
            }

            // Add segment query string if not empty
            if (this.filters.segments.length) {
                add_query_strings.segment = this.filters.segments.join(',');
            } else {
                remove_query_strings.push('segment');
            }

            // Add or remove multiple query strings using Router.addMultipleQueryString
            Router.addMultipleQueryString(add_query_strings, {trigger: false});
            Router.removeQueryString(remove_query_strings, {trigger: false});
        }

        // check the quick search clear button
        this.$el.find('.quick-search-clear').toggle(this.search_val ? true : false);
        this.$el.find('.loading-state').show();

        Cache.app.request({
            action: 'survey_response/search',
            data: {
                page              : this.page,
                limit             : this.limit,
                survey_id         : this.survey.id,
                search            : this.search_val,
                date_start        : this.filters.date_start,
                segment_id        : this.filters.segments.length === 0 ? undefined : this.filters.segments[0],
                user_properties   : this.filters.user_properties,
                question_condition: this.filters.question_condition
            },
            success: (response) => {
                this.total = response.total;
                this.total_responses = response.total_responses;
                this.user_data = response.user_data;

                Cache.survey_response.reset(response.data);

                if (on_success) {
                    on_success();
                }
            },
            complete: () => {
                this.$el.find('.loader-body').remove();
                this.$el.find('.loading-state').hide();
            }
        });
    },

    onClearSelection: function() {
        this.selected_ids = [];
        this.$el.find('td.select input').prop('checked', false);
        this.$el.find('.fullscroll-action-bar > div').removeClass('flip');

        // clear select all
        this.$el.find('.select-all input').prop('checked', false);
    },

    onPageReady: function() {
        this.search(() => {
            var response_id = Router.getQueryString('id');

            if (response_id) {
                var response_model = Cache.survey_response.get(response_id);

                if (response_model) {
                    Modals.openSurveyResponse(response_model, this.user_data, Cache.survey_response.models);
                } else {
                    // TODO: when the model is not in the loaded collection, we need to fetch it from the server
                }
            }
        }, true);
    },

    validateStartDate: function() {
        const available_dates = [0, 1, 7, 30, 90, 365];
        var date_start = parseInt(Router.getQueryString('d'), 10);
        if (isNaN(date_start) || available_dates.indexOf(date_start) === -1) {
            date_start = parseInt(Cache.app.getUserSetting('survey_response_filter_date', true), 10);
        }

        if (available_dates.indexOf(date_start) === -1) {
            date_start = 0;
        }

        return date_start;
    },

    validateSegement: function() {
        // check router first
        const segment = Router.getQueryString('segment');
        let is_router_valid = false;

        if (segment) {
            const segment_ids = segment.split(',').map((segment_id) => {
                return parseInt(segment_id, 10);
            }).filter((segment_id) => {
                return Cache.user_segment.get(segment_id) ? true : false;
            });

            if (segment_ids.length) {
                is_router_valid = true;
                return segment_ids;
            }
        }

        // check cache
        if (!is_router_valid) {
            const segment_cache = Cache.app.getUserSetting('survey_response_filter_segment', true);
            if (segment_cache) {
                const segment_ids = segment_cache.split(',').map((segment_id) => {
                    return parseInt(segment_id, 10);
                }).filter((segment_id) => {
                    return Cache.user_segment.get(segment_id) ? true : false;
                });

                if (segment_ids.length) {
                    return segment_ids;
                }
            }
        }

        return [];
    },

    validateUserProperties: function() {
        // check router first
        const user_properties = Router.getQueryString('user_property');
        let is_router_valid = false;
        if (user_properties) {
            try {
                const user_properties_obj = JSON.parse(user_properties);
                if (user_properties_obj.segment_condition) {
                    is_router_valid = true;
                    if (!Array.isArray(user_properties_obj.segment_condition)) {
                        user_properties_obj.segment_condition = [];
                    }
                    if (user_properties_obj.segment_type !== Constants.USER_SEGMENT_TYPE_AND &&
                        user_properties_obj.segment_type !== Constants.USER_SEGMENT_TYPE_OR
                    ) {
                        user_properties_obj.segment_type = Constants.USER_SEGMENT_TYPE_AND;
                    }
                    return user_properties_obj;
                }
            } catch (e) {
            }
        }

        // check cache
        if (!is_router_valid) {
            const user_properties_cache = Cache.app.getUserSetting('survey_response_filter_user_properties', true);
            if (user_properties_cache) {
                try {
                    const user_properties_obj = JSON.parse(user_properties_cache);
                    if (user_properties_obj.segment_condition) {
                        if (!Array.isArray(user_properties_obj.segment_condition)) {
                            user_properties_obj.segment_condition = [];
                        }
                        if (user_properties_obj.segment_type !== Constants.USER_SEGMENT_TYPE_AND &&
                            user_properties_obj.segment_type !== Constants.USER_SEGMENT_TYPE_OR
                        ) {
                            user_properties_obj.segment_type = Constants.USER_SEGMENT_TYPE_AND;
                        }
                        return user_properties_obj;
                    }
                } catch (e) {
                }
            }
        }

        return {
            segment_type: Constants.USER_SEGMENT_TYPE_AND,
            segment_condition: []
        };
    },

    validateQuestionCondition: function() {
        // check router first
        const question_condition = Router.getQueryString('question_condition');
        let is_router_valid = false;
        if (question_condition) {
            try {
                const question_condition_obj = JSON.parse(question_condition);
                if (question_condition_obj.question_condition) {
                    if (!Array.isArray(question_condition_obj.question_condition)) {
                        question_condition_obj.question_condition = [];
                    }

                    is_router_valid = true;
                    // check question_condition_type is valid
                    if (question_condition_obj.question_condition_type !== Constants.QUESTION_CONDITION_TYPE_AND &&
                        question_condition_obj.question_condition_type !== Constants.QUESTION_CONDITION_TYPE_OR
                    ) {
                        question_condition_obj.question_condition_type = Constants.QUESTION_CONDITION_TYPE_AND;
                    }

                    return question_condition_obj;
                }
            } catch (e) {
            }
        }
        // check cache
        if (!is_router_valid) {
            const question_condition_cache = Cache.app.getUserSetting('survey_response_filter_question_condition', true);
            if (question_condition_cache) {
                try {
                    const question_condition_obj = JSON.parse(question_condition_cache);
                    if (question_condition_obj.question_condition) {
                        if (!Array.isArray(question_condition_obj.question_condition)) {
                            question_condition_obj.question_condition = [];
                        }

                        if (question_condition_obj.question_condition_type !== Constants.QUESTION_CONDITION_TYPE_AND &&
                            question_condition_obj.question_condition_type !== Constants.QUESTION_CONDITION_TYPE_OR
                        ) {
                            question_condition_obj.question_condition_type = Constants.QUESTION_CONDITION_TYPE_AND;
                        }

                        return question_condition_obj;
                    }
                } catch (e) {
                }
            }
        }

        return {
            question_condition_type: Constants.QUESTION_CONDITION_TYPE_AND,
            question_condition: []
        };
    },

    renderDataTable: function() {
        var is_loading = this.total === null;
        var question_header = '';
        var question_loader = '';
        var loader_body     = '';

        this.questions.forEach((model) => {
            question_header += '<th class="question neutral"><div><span class="ellipsis tooltip" data-title="' + model.getLabel(true) + '">' + model.getLabel(true) + '</span></div></th>';
            question_loader += '<td><div class="loader-placeholder-small" style="width:120px;"></div></td>';
        });

        for (var i = 1; i <= 5; i++) {
            loader_body +=
            '<tr class="loader-body">' +
                '<td></td>' +
                '<td><div class="loader-placeholder-small" style="width:40px;"></div></td>' +
                '<td><div class="loader-placeholder-small" style="width:80px;"></div></td>' +
                '<td><div class="loader-placeholder-small" style="width:80px;"></div></td>' +
                '<td><div class="loader-placeholder-small" style="width:80px;"></div></td>' +
                question_loader +
            '</tr>';
        }

        var content =
        '<div class="response-action-bar">' +
            '<div class="response-count">' +
                (is_loading ?
                '<div class="loader-placeholder-small" style="width:80px;"></div>' :
                Numeral(this.total).format('0,0') + ' response' + (this.total === 1 ? '' : 's')) +
            '</div>' +
            (is_loading ? '' :
            '<div class="loading-state">Loading...</div>') +
        '</div>' +
        '<div>' +
            '<table cellpadding="0" cellspacing="0" class="sticky-header">' +
                '<thead>' +
                '<tr>' +
                    '<th width="50" class="select-all"><input type="checkbox" id="survey_response_select_all"><label for="survey_response_select_all"></label></th>' +
                    '<th width="80"><span class="badge-id"></span></th>' +
                    '<th width="140">Date</th>' +
                    '<th width="200">User <i class="fa-solid fa-badge-check text-icon"></i></th>' +
                    question_header +
                    '<th width="200" class="question">Location</th>' +
                '</tr>' +
                '</thead>' +
                '<tbody>' +
                (is_loading ? loader_body : '') +
                '</tbody>' +
            '</table>' +

            (is_loading ? '' :
            (this.total > 0 ?
            '<div class="region-pagination text-align-center">' +
                '<div class="button-group" data-autohighlight="false">' +
                    '<button class="page-previous text small inline"><i class="far fa-angle-left"></i></button>' +
                    '<button class="small inline current-page"><b>' + this.page + ' of ' + Math.ceil(this.total / this.limit) + '</b></button>' +
                    '<button class="page-next text small inline"><i class="far fa-angle-right"></i></button>' +
                '</div>' +
            '</div>' :
            '<p class="empty-state">' + (this.total_responses > 0 ? 'No responses found.' : 'No responses have been collected yet.') + '</p>')) +
        '</div>';

        this.$el.find('.region-responses').html(content);

        if (this.total !== null) {
            _.each(this.views.response_rows, (view) => {
                view.render().$el.appendTo(this.$el.find('tbody'));
            });
        }
    },

    render: function() {
        UI.setPageTitle('Responses');

        var content =
        '<div class="fullscroll-action-bar">' +
            '<div>' +
                '<div class="region-search">' +
                    '<div class="search">' +
                        '<form class="quick-search">' +
                            '<input type="text" name="search" placeholder="Search responses" maxlength="100">' +
                            '<button type="button" class="quick-search-clear tooltip" data-title="Clear search"><i class="fas fa-times-circle info"></i></button>' +
                        '</form>' +
                    '</div>' +
                    '<div class="survey-response-filter-container">' +
                        '<div class="region-filters"></div>' +
                        (Cache.account.hasFeature('export_feedback') ?
                        '<div class="action-buttons">' +
                            '<button type="button" class="response-export small tertiary min">Export</button>' +
                        '</div>' : '') +
                    '</div>' +
                '</div>' +
                '<div class="region-group-action">' +
                    '<div class="item-counter">' +
                        '<span class="num"></span> selected' +
                        '<a href="#" class="clear-selection tooltip" data-title="Clear"><i class="fas fa-times-circle info"></i></a>' +
                    '</div>' +
                    '<div class="action-buttons">' +
                        '<button type="button" class="delete square small secondary">Delete</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="region-responses"></div>';

        this.$el.html(content);

        this.renderDataTable();

        this.views.filters.render().$el.appendTo(this.$el.find('.region-filters'));

        Form.setData(this.$el.find('.quick-search'), {
            search: this.search_val
        });

        this.$el.find('.quick-search-clear').toggle(this.search_val ? true : false);

        return this;
    }
});

export default Page_Survey_Results;